import { render, staticRenderFns } from "./export.vue?vue&type=template&id=36bdd9ee&lang=pug"
import script from "./export.vue?vue&type=script&lang=js"
export * from "./export.vue?vue&type=script&lang=js"
import style0 from "./export.vue?vue&type=style&index=0&id=36bdd9ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports